import Layout from "layouts/Layout";
import Auth from "modules/Auth/Middleware/Auth";
import RaffleOcrActivityContent from "modules/RaffleOcrActivity";

import React from "react";
import { setTitle } from "utilities/helper/setTitle";

const RaffleOcrActivityPage: React.FC = () => {
  setTitle("Raffle OCR Activity");
  return (
    <Auth>
      <Layout>
        <RaffleOcrActivityContent />
      </Layout>
    </Auth>
  );
};

export default RaffleOcrActivityPage;
